export default {
  name: 'BtnToggle',
  props: {
    options: {
      type: Array,
      required: true,
      validator: v => v.every(
        opt => (
          'label' in opt ||
          'icon' in opt ||
          'slot' in opt ||
          'slotBeforeIcon' in opt ||
          'slotAfterIcon' in opt
        ) && 'value' in opt,
      ),
    },
    size: {
      type: String,
      default: 'l',
      validator: (value) => {
        return ['l', 'm', 's'].indexOf(value) !== -1;
      },
    },
    value: undefined,
    clearable: Boolean,
    valuePropName: {
      type: String,
      default: '',
    },
  },
  computed: {
    sizeClass() {
      return this.size ? ' btn-toggle--size-' + this.size : '';
    },
  },
  methods: {
    __set(value, opt, e) {
      if (opt.disable) return;
      if (this.isTrue(value)) {
        if (this.clearable === true) {
          this.$emit('input', null, null);
          this.$emit('clear');
        }
        this.$emit('click-self', value, opt);
      } else {
        this.$emit('input', value, opt);
      }

      this.$emit('click', e);
    },
    isTrue(value) {
      if (
        typeof value === 'object' &&
        typeof this.value === 'object' &&
        this.valuePropName
      ) {
        return value[this.valuePropName] === this.value[this.valuePropName];
      } else {
        return value === this.value;
      }
    },
    getKey(value) {
      if (
        typeof value === 'object' &&
        this.valuePropName
      ) {
        return value[this.valuePropName];
      } else {
        return value;
      }
    },
  },
};
